import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const startBatchBrandAndCompetitorMention = unaryRpc({
  name: "startBatchBrandAndCompetitorMention",
  input: z.object({
    processingStartDate: z.date(),
    teamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    workflowId: z.string(),
    status: z.literal("started"),
    teamsQueued: z.number(),
  }),
});
